import { Grid } from "@mui/material";
import ImageBackground from '../../Assets/Images/background-contnt.png'
import '../../Assets/Styles/Customer/customer-info.css';
import { t } from "i18next";
import useWindowDimensions from "../../Components/useWindowDimension";
import { useTranslation } from "react-i18next";
import * as CustomerService from '../../Services/customer-service';
import '../../Assets/Styles/Customer/customer-account-info.css'
import { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-nextgen";
import _ from "lodash";
import CustomNav from "../../Components/custom-nav/CustomNav";
import FooterCustomer from "../../Layouts/footer/FooterCustomer";
import '../../Assets/Styles/Customer/font-size.css'
import { countTimeExpired } from "../../Services/service";

export default function CustomerAccountInfomation() {
    const [objectDto, setObjectDto] = useState(localStorage.getItem("aaa") !== null ? JSON.parse(localStorage.getItem("aaa")) : null);
    countTimeExpired(objectDto, setObjectDto);
    const [activeItem, setActiveItem] = useState({ title: t("customerinfo"), icon: <i class="fa fa-folder" aria-hidden="true"></i>, content: "", no: 0 });
    const { height, width } = useWindowDimensions();
    const [account, setAccount] = useState(null);
    const [info, setInfo] = useState([]);
    const { i18n } = useTranslation();
    useEffect(() => {
        document.title = "Phu Hung Life - Khach Hang"
    }, []);
    useEffect(() => {
        if (objectDto === null) {
            CustomerService.LogOut(setObjectDto);
        } else if (account !== undefined && account !== null) {
            setInfo([
                { "title": t("laName"), "value": account.poName },
                { "title": t("dob"), "value": account.dob },
                { "title": t("gender"), "value": account.gender },
                { "title": t("usernamecustomer"), "value": account.poIdNumber },
                { "title": t("iddate"), "value": account.poIdDate },
                { "title": t("address"), "value": account.address },
                { "title": t("phone"), "value": account.poPhone },
                { "title": t("email"), "value": account.email }
            ])
        } else {
            CustomerService.getAccountInfo(objectDto, setObjectDto, setAccount);
        }
    }, [account])
    useEffect(() => {
    }, [i18n]);
    const divStyle = {
        backgroundImage: `url(${ImageBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100vw',
        height: height,
        backgroundRepeat: 'no-repeat'
    };
    return (
        <>
            <div className='nav-container' style={{ height: height }}>
                <CustomNav activeItem={activeItem} setActiveItem={setActiveItem} objectDto={objectDto} setObjectDto={setObjectDto} width={width} height={height} />
                <div className="customer-info-container" style={divStyle}>
                    {/* <CustomChangeLanguage /> */}
                    {
                        account !== null ?
                            <Grid container spacing={1} className="grid-account-info">
                                <Grid item xs={6} sm={6} paddingBottom={"1%"}>
                                    <span className="title-header-account-info header-title-customer">{t("customerinfo")}</span>
                                </Grid>
                                <Grid className="col-end header-title-customer" item xs={6} sm={6}>
                                    {
                                        account.vipType !== "" ? <label size="small" className="label-tier-account-info description-small-customer">{t('tier') + (account.vipType === "PLATINUM" ? "Bạch Kim" : account.vipType === "DIAMOND" ? "Kim Cương" : account.vipType === "GOLD" ? "Vàng" : "")}</label>
                                            : ""
                                    }
                                </Grid>
                                {info.map((item) => (
                                    <>
                                        <Grid item xs={width < 375 ? 4.5 : 4} sm={3}>
                                            <div className="title-account-info description-small-customer">
                                                <span style={{ paddingLeft: '5%' }}>{item.title}</span></div>
                                        </Grid>
                                        <Grid item xs={width < 375 ? 7.5 : 8} sm={9}>
                                            <div className="desciption-account-info description-small-customer">
                                                <span style={{ paddingLeft: '1%' }}>{item.value}</span></div>
                                        </Grid>
                                    </>
                                ))
                                }
                            </Grid>
                            :
                            <LoadingOverlay className="loading_overlay_content_customer" active={true} spinner text={t("loading")} />
                    }
                </div>
            </div>
            <FooterCustomer />
        </>
    )
};
